export class Filter {

	public static filtrer(list: any[], nomAttribut: string, filtre: string) {
		return list.filter(function (data) {
			return data[nomAttribut].toLowerCase().indexOf(filtre.toLowerCase()) !== -1 || !filtre;
		});
	}
}


